import React, { useState, useEffect } from "react";
import { Typography, Grid, Container } from "@mui/material";
import api from "../../globals/axios";
import { useParams } from "react-router-dom";
import CustomAppBar from "../../components/AppBar";
import LoaderContainer from "../../components/LoaderContainer";
import DownLoadIcon from "../../assets/Icon/DownLoadIcon.png";
import ViewIcon from "../../assets/Icon/ViewIcon.png";
import CustomCardView from "../../components/Custom/CardView";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import {
  CustomLabel,
  CustomValue,
} from "../../components/Custom/CustomTypography";
import { useTranslation } from "react-i18next";
export default function LabTestView() {
  const { t } = useTranslation();
  const { labId } = useParams();
  const [loading, setLoading] = useState(true);
  const [tokenData, setTokenData] = useState({
    crop_type: "",
    lab_name: "",
    test_date: "",
    report_date: "",
    crop: [],
  });
  const labelValuePairs = [
    { label: "Crop Name", value: tokenData?.crop?.commodity?.name ?? "" },
    { label: "Lab Name", value: tokenData?.lab_name ?? "" },
    { label: "Test Date", value: tokenData?.report_date ?? "" },
    { label: "Report Date", value: tokenData?.report_date ?? "" },
  ];
  const loadNFT = async () => {
    try {
      const res = await api.get(`/farmer/lab_test/${labId}`);
      const data = res.data;
      setTokenData(data);

      setLoading(false);
    } catch (error) {
      console.error("Error loading farm data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    loadNFT();
  }, [labId]);

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container maxWidth="xs" sx={{ padding: "18px" }}>
          <CustomTitle>{t("Lab Test View")}</CustomTitle>
          <Grid
            container
            direction="column"
            style={{ marginTop: "10px" }}
            spacing={0}
          >
            {labelValuePairs.map((pair) => (
              <Grid item container key={pair.label}>
                <Grid item xs={5}>
                  <CustomLabel>{t(pair.label)}</CustomLabel>
                </Grid>
                <Grid item xs={1}>
                  <CustomLabel>:</CustomLabel>
                </Grid>

                <Grid item xs={6}>
                  <CustomValue>{pair.value}</CustomValue>
                </Grid>
              </Grid>
            ))}

            {/* Farm Document Text */}

            <Grid item xs={12}>
              <CustomLabel>{t("Legal Document")}:</CustomLabel>
            </Grid>
            <Grid container item xs={9} alignItems="center">
              <Grid item xs={9}>
                <CustomValue>
                  {tokenData.lab_report ? (
                    <Typography style={{ fontSize: "12px" }}>
                      {tokenData.lab_report.split("/").pop().split("?")[0]}
                    </Typography>
                  ) : (
                    t("No farm document available")
                  )}
                </CustomValue>
              </Grid>
              {tokenData.lab_report && (
                <>
                  <Grid item xs={1} columnGap={2} sx={{ marginTop: "10px" }}>
                    <a href={tokenData.lab_report} target="_blank" rel="noreferrer">
                      <img src={ViewIcon} alt="View Icon" />
                    </a>
                  </Grid>
                  <Grid
                    item
                    xs={1}
                    sx={{ marginLeft: "20px", marginTop: "10px" }}
                    // onClick={handleDownload}
                  >
                    <img src={DownLoadIcon} alt="Download Icon" />
                  </Grid>
                </>
              )}
            </Grid>

            {/* Card Section for Crop Information */}
            <Grid
              item
              style={{
                marginTop: "20px",
                marginBottom: "20px",
                padding: "5px",
              }}
            >
              {tokenData.crop && <CustomTitle>Crop</CustomTitle>}

              <CustomCardView
                crop={tokenData.crop}
                t={t}
                dialogData={[
                  { label: t("Crop Type"), value: tokenData.crop.crop_type },
                  {
                    label: t("Sowing Date"),
                    value: tokenData.crop.sowing_date,
                  },
                  {
                    label: t("Estimated Harvest"),
                    value: tokenData.crop.estimated_harvest,
                  },
                  {
                    label: t("Estimated Harvest Date"),
                    value: tokenData.crop.estimated_harvest_date,
                  },
                  {
                    label: t("Seed Quantity"),
                    value: tokenData.crop.seed_quantity,
                  },
                ]}
              />
            </Grid>
          </Grid>
        </Container>
      </LoaderContainer>
    </>
  );
}
